var React = require('react');
 import {CreateEntertainer } from '../actions/LoginServiceCreator';
 import {UpdateLikeEntertainer} from '../actions/WebsiteLoadCreator';
import Facebook from './Facebook';
var cookie = require('react-cookie');
var userLiked = [];

class EntertainerResult extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func
  }

  render() {
    if (cookie.load('logged_in') === 1) {
      window.location.href = '/';
      return;
    }
    var inputs = this.props.entities;
     userLiked.push(inputs? JSON.parse(inputs[0].likevector) : '');
    return (
      <div>
        <div id="content" className="container-fluid" style={ { 'overflow': 'hidden', 'padding': '2%', 'margin-top': '5%' } }>
          <div className="row-fluid clearfix ">
            {
              inputs.map(function(item, index){
                return(
                  <div className="col-md-12 col-sm-12 col-xs-12 resultscontainer">
                    <div className="LeftItem-container">
                      <img className="leftimg" src= {item.image} />
                      <div className="RightItem-container">
                        <div className="entertaineritem-title"> {item.title}</div>
                        <div className="entertaineritem-address">{item.address}</div>
                        <div className="entertaineritem-cuisines">{item.cuisines}</div>
                      </div>
                      { userLiked[0] ?
                          (userLiked[0].indexOf(item.id) != -1) ?
                            <img className="close-btn spacing heart" onClick={ this.likeit.bind(this) } id={index} data-likeiness={'0'} style={{"margin-right":"2em"}}  src={"https://k-s3bkp.s3.eu-west-2.amazonaws.com/folink/icons/HeartFill.png"} />
                            :
                             <img className="close-btn spacing heart" onClick={ this.likeit.bind(this) } id={index} data-likeiness={'0'} style={{"margin-right":"2em"}}  src={" https://k-s3bkp.s3.eu-west-2.amazonaws.com/folink/icons/heart_grey.png"} />
                              :  <img className="close-btn spacing heart" onClick={ this.likeit.bind(this) } id={index} data-likeiness={'0'} style={{"margin-right":"2em"}}  src={"https://k-s3bkp.s3.eu-west-2.amazonaws.com/folink/icons/heart_grey.png"} />
                            }
                  </div>
                </div>
              )
            }.bind(this))
          }
          </div>
        </div>
      </div>
    );
  }
  likeit(){
    //if(this.props.logindata.logged_in === 1 || this.props.logindata.logged_in === 2){
        $(".whirly-loader").css('visibility', 'visible');
        var index = Number(event.target.id);
        var inputs = this.props.entities.inputs;
        var self = this;
        var likeid,
          dislikeid,
          dislikedagainstid;
        var indextoreplacefrom = 3 + (Math.floor(this.props.entities[index].index / 3) * 3);
        var likeiness = event.target.dataset.likeiness;
        var idstoberepalced = '';
        if (likeiness === '0') {
          likeid = this.props.entities[index].id;
        } else if (likeiness === '4' || likeiness === '3') {
          dislikedagainstid = inputs[index];
          dislikeid = this.props.entities[index].id;
        }
        if (['0', '4', '3'].indexOf(likeiness) > -1) {
          var Entertainer = cookie.load("Entertainer", true);
          var ArrEntertainer =[];
          ArrEntertainer.push(Entertainer);
          var value = JSON.parse(ArrEntertainer);
          likeid = likeid.replace(/ /g, "");
          console.log("like",likeid);
          self.context.executeAction(UpdateLikeEntertainer, {
            likeid: likeid,
            userid: value.id
          });
        }
        userLiked[0].push(likeid);


  }

}

module.exports = EntertainerResult;



// WEBPACK FOOTER //
// ./src/components/EntertainerResult.js